export default __webpack_public_path__ + "static/media/contactsGreen.808a7bb5.svg";